const DESIRED_ACTIVE = "active";

export const selectCalendarActiveAutomations = ({
  automations = {},
  now = Date.now(),
}) =>
  Object.entries(automations)
    .filter(([, automation]) => automation?.desiredStatus === DESIRED_ACTIVE)
    .filter(([, automation]) => {
      const activeUntil = Number(automation?.schedule?.activeUntil);
      if (Number.isFinite(activeUntil) && activeUntil > 0 && now > activeUntil) {
        return false;
      }
      return true;
    })
    .map(([id, automation]) => ({
      id,
      name: automation.name || "",
      folderLabel:
        automation.source?.type === "folder"
          ? automation.source?.folderName || ""
          : "",
      activeUntil: Number(automation.schedule?.activeUntil) || null,
      timezone: automation.schedule?.timezone || "",
    }))
    .sort((left, right) => left.name.localeCompare(right.name));
